angular.module('common.directives.omNumericTextBox', [])
    .directive('omNumericTextBox', function ($compile, $interpolate) {
        //We need a custom directive to wrap kendo-numeric-text-box directive
        //to overcome the issues of the kendo creature.
        //There is an issue with it as it expects the placeholder to be expression,
        //thus, we need to put single quotes around any text content we put into placeholder.
        //Also it emits internally second input to show value and uses original input to edit value.
        //Therefore the titles and placeholders of those inputs are different as the values are 
        //evaluated at different point in time.
        //
        //So we create our wrapper directive, compile it from template where we assign all the
        //properties assigned to our directive to the underlying kendo directive with necessary
        //fixes to overcome its issues to not to force user (application engineer) to do that.
        return {
            priority: 2000,
            restrict: 'AE',
            terminal: true,
            scope: false,
            compile: function compile(element, attrs) {
                //Creating input to assign kendo directive to
                var input = $("<input>").attr('kendo-numeric-text-box', '');
                //Transfer all properties applied to the this input from our directive
                //skipping placeholder as it needs to be treated in different manner
                angular.forEach(attrs, function (value, name) {
                    if (!_.string.startsWith(name, '$') && name != 'placeholder') {
                        input.attr(attrs.$attr[name], $interpolate(value));
                    }
                });
                //Set kendo placeholder via kendo options object
                input.attr("k-options", "{placeholder:'" + attrs.placeholder + "'}");

                //In order to make our focus directive that allows barcode scanners support
                //to be able to focus/select the real input to enter new value, we have to
                //catch the situation when 'focus' directive tries to focus our directive's 
                //root container where it ('focus') was intially applied. And when we catch
                //that, we have to find the 'visible' input that kendo uses to show value,
                //and focus it. And after that kendo internally will hide it, show input
                //for entering values and focuses it. 
                //Kendo magic, sad but true.
                input.on("select", function () {
                    input.siblings("input:visible").focus();
                });

                //And finally for the kendo directive to be able to compile and build its DOM to
                //incorporate it around our input we created above, we need to put that input
                //into some container. Otherwise kendo directive will just not finish its compile routine.
                var inputContainer = $("<div></div>").append(input);

                //Actually do compile.
                var cmp = $compile(inputContainer);

                //And return a link function inside which we append the resulted element to our directive's 
                //container.
                return function postLink(scope, element, attrs, controller) {
                    element.append(cmp(scope));
                }
            }
        };
    });